import { Component, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ModalButton } from './modal-base.interface';

@Component({
  template: '',
})
export abstract class BaseModalComponent {
  @Input() title = '';
  @Input() buttons: ModalButton[] = [];

  constructor(protected modalCtrl: ModalController, protected navCtrl: NavController) {}

  protected dismiss(data?: any) {
    this.modalCtrl.dismiss(data);
  }

  protected handleButtonClick(button: ModalButton) {
    if (button.handler) {
      button.handler();
    }
    this.dismiss();
    if (button.redirectPath) {
      this.navCtrl.navigateRoot([button.redirectPath]);
    }
  }
}
